import { buildBinderListings } from '@monofe/di';
import buildDeleteTour from './delete-tour/bind';
import buildDialog from './dialog/bind';
import buildDownloadLanguage from './download-language/bind';
import buildDownloadTour from './download-tour/bind';
import buildOfflineToast from './offline-alert/bind';
import buildToast from './toast/bind';

export default buildBinderListings([
    buildToast,
    buildDialog,
    buildDownloadTour,
    buildDeleteTour,
    buildDownloadLanguage,
    buildOfflineToast,
]);
